import { DeviceStorage } from '@frontend/deviceStorage';
import { AuthenticationAPI } from '../api';
import { IAuthenticationState } from '../state';

export const validate_session_factory = (
    api: AuthenticationAPI,
    state: IAuthenticationState,
    device_storage: DeviceStorage,
) => async () =>{
    const validated = await api.validate_session();
    if (validated instanceof Error) {
        state.session_type.value = new Set();
        device_storage.user_subscription_status = 'free';
        device_storage.user_trial_end = undefined;
    } else {
        state.session_type.value = new Set(validated.session_type);
        device_storage.user_subscription_status = validated.subscription_status;
        device_storage.user_trial_end = validated.trial_end ?? undefined;
        console.log("P11:")
        console.log(validated.trial_end)

    }
};
